import { z } from 'zod';

// A LaborSupplier is an external manpower agency. AGENCY-type employees are
// tracked-hours and billed back to their supplier (no payslip, no WPS). Money
// fields are plain non-negative numbers on the wire; the service coerces them
// to Prisma Decimal. Mirrors the Designation CRUD Input/Schema split.
export const LaborSupplierInputSchema = z.object({
  name: z.string().min(1).max(120),
  trnNumber: z.string().max(20).optional().nullable(),
  contactInfo: z.string().max(500).optional().nullable(),
  hourlyRate: z.number().nonnegative().optional().nullable(),
  dayRate: z.number().nonnegative().optional().nullable(),
  isActive: z.boolean().default(true),
});
export type LaborSupplierInput = z.infer<typeof LaborSupplierInputSchema>;

export const LaborSupplierSchema = LaborSupplierInputSchema.extend({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type LaborSupplier = z.infer<typeof LaborSupplierSchema>;
